import { Component } from 'react';
import type { ReactNode } from 'react';
import { Icone } from './Icone';

/**
 * PROTEÇÃO DE TELA — um erro dentro de uma tela não pode deixar o sistema inteiro em branco.
 * A tela que falhou mostra o aviso e o botão de recarregar; o menu continua funcionando, e
 * trocar de tela (outra `chave`) limpa o erro.
 */
export class ProtecaoDeTela extends Component<
  { chave: string; children: ReactNode },
  { erro: Error | null; chave: string }
> {
  override state: { erro: Error | null; chave: string } = { erro: null, chave: this.props.chave };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  static getDerivedStateFromProps(p: { chave: string }, s: { erro: Error | null; chave: string }) {
    return p.chave !== s.chave ? { erro: null, chave: p.chave } : null;
  }

  override componentDidCatch(erro: Error) {
    console.error('[InovaPay] erro na tela', erro);
  }

  override render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="es-vazio es-erro-area" role="alert" style={{ margin: 24 }}>
        <span className="es-vazio-icone es-icone-erro" aria-hidden="true">
          <Icone nome="warn" tamanho={17} traco={1.6} />
        </span>
        <div className="es-vazio-titulo">Esta tela encontrou um erro</div>
        <div className="es-vazio-texto">
          O resto do sistema continua funcionando. Recarregue a página; se voltar, avise o suporte
          com o horário.
        </div>
        <div className="es-acoes">
          <button type="button" className="es-botao" onClick={() => window.location.reload()}>
            <Icone nome="cycle" tamanho={15} traco={1.6} />
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
